<template>
  <article>
    <h2>About me</h2>
    <p>Hi, i am a designer from Hong Kong. As my position is a full stack designer, that's mean i can design from graphic to user experience, also the front-end programming. </p>
    <p>When I design website UI for coder at the beginning, but they always create website exactly not i want. So I try to build it myself, from CSS / HTML to jquery.</p>
    <p>But jquery still have limitation. Performance problems and only can run at front-end, so i learn some php for layout templating</p>
    <p>After try to build some website with javascript frameworks. I think this is the way i want to extend. I build this website with full javascript framework, also with REST API for contact form.</p>
  </article>
</template>

<script>
  export default {
    name: 'AboutMe'
  }
</script>

<style scoped lang="scss">
  article {
    h2 {
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/about/AboutMe.vue